import React from "react";
import validaciones from "../../../../../helpers/validaciones";
import TextField from "../../../../Shared/fields/TextField";
import SelectField from "../../../../Shared/fields/SelectField";
import NumberField from "../../../../Shared/fields/NumberField";

export const INPUT_TYPES = {
  TEXT: "text",
  SELECT: "select",
  DATE: "date",
  NUMBER: "number",
  RANGE: "range",
};

export const INPUT_ERRORS = {
  personName:
    "Sólo caracteres alfanuméricos con espacio, puntos y guión; sin ñ, ni comas y máximo 100 caracteres.",
  name:
    "Sólo caracteres alfanuméricos con espacio, puntos y guión; sin ñ",
  email: "Email inválido",
  phone: "Teléfono inválido. Ejemplo: 9 9123 4567.",
  rut: "RUT inválido",
  sex: "Sexo debe ser M o F",
  number: "Solo números, sin puntos, comas, espacios ni guiones",
  movimientoPersonal:
    "El valor de movimineto personal debe ser solo: 0; 1; 2; 3; 4; 5; 6; 13; 14; 15 ó 20",
  invalidFileType: "El archivo debe ser excel: .csv; .xls ó .xlsx",
};

export const MESES = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

const REGIONES = [
  "Región de Arica y Parinacota",
  "Región de Tarapacá",
  "Región de Antofagasta",
  "Región de Atacama",
  "Región de Coquimbo",
  "Región de Valparaíso",
  "Región Metropolitana",
  "Región de O'Higgins",
  "Región del Maule",
  "Región de Ñuble",
  "Región del Biobío",
  "Región de La Araucanía",
  "Región de Los Ríos",
  "Región de Los Lagos",
  "Región de Aysén",
  "Región de Magallanes",
];

export const validName = (value) => /^[\w \. \- \d\A-zÀ-ú]{1,100}$/.test(value);
export const validStreet = (value) => /^[\w \. \-\,\d\A-zÀ-ú]{1,30}$/.test(value);
export const onlyNumbers = (value) => /^\d+$/.test(value);
export const validMovimientoPersonal = (value) => {
  const possibleValues = [0, 1, 2, 3, 4, 5, 6, 13, 14, 15, 20];

  let isValid = false;
  possibleValues.some((posValue) => {
    isValid = posValue === +value;
    return isValid;
  });

  return isValid;
};
export const onlyNumbersFormatter = (value) => {
  // value = value || 999999999;
  value = value || "";
  // value
  value = value.replace(/\D/g, "");
  return value
};

export const noDecimalsFormatter = (value) => {
  return parseInt(value).toString()
};

export const Input = ({ input, handleChange, value, disabled }) => {
  const {
    inputType,
    name,
    maxLength,
    label,
    validationCallback,
    formatter,
    validationMessage,
    options,
    dataSource,
    displayExpr,
    valueExpr,
    placeholder,
    maxNum,
    minNum,
    showSpinButtons,
    required,
    skipValidation,
    style
  } = input;
  disabled = disabled || input.disabled;

  if (inputType === INPUT_TYPES.TEXT) {
    return (
      <TextField
        style={style}
        required={required || true}
        skipValidation={skipValidation}
        id={name}
        maxLength={maxLength || 1000}
        value={value}
        label={label}
        placeholder={placeholder}
        disabled={disabled}
        onChange={({ value }) =>
          handleChange(formatter ? formatter(value) : value, name)
        }
        customRules={{
          type: "custom",
          message: validationMessage,
          validationCallback,
        }}
      />
    );
  } else if (inputType === INPUT_TYPES.SELECT) {
    return (
      <SelectField
        style={style}
        required={required || true}
        skipValidation={skipValidation}
        label={label}
        id={name}
        value={value}
        items={options}
        dataSource={dataSource}
        displayExpr={displayExpr}
        valueExpr={valueExpr}
        disabled={disabled}
        onValueChanged={({ value }) => handleChange(value, name)}
      />
    );
  } else if (inputType === INPUT_TYPES.NUMBER) {
    return (
      <NumberField
        style={style}
        skipParse={true}
        required={required || true}
        skipValidation={skipValidation}
        inputAttr={{ maxLength }}
        max={maxNum}
        min={minNum}
        value={value}
        label={label}
        id={name}
        showSpinButtons={showSpinButtons}
        onChange={({ value }) => {return handleChange(onlyNumbersFormatter(value), name)}}
      />
    );
  }
};

export const addZeroToNum = (num) => (num[0] === "0" ? num : +num < 10 ? `0${num}` : num);

export const genFolioNum = () => {
  const date = new Date();
  const day = date.getDate().toString();
  const dayLastDigit = day[day.length - 1];
  return `${dayLastDigit === "0" ? "1" : dayLastDigit}${addZeroToNum(date.getHours())}${addZeroToNum(date.getMinutes())}${addZeroToNum(date.getSeconds())}`;
};

export const isExcelFile = (file) => {
  return (
    file.type === ".csv" || ".xlsx" ||
    file.type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
    file.type === "application/vnd.ms-excel"
  );
};

export default {
  step1: [
    {
      inputType: INPUT_TYPES.TEXT,
      name: "nombreRazonSocial",
      label: "Nombre razón social",
      placeholder: "Nombre razón social",
      maxLength: 100,
      validationCallback: ({ value }) => validName(value),
      validationMessage: INPUT_ERRORS.personName,
    },
    {
      inputType: INPUT_TYPES.TEXT,
      name: "rutRazonSocial",
      label: "RUT",
      placeholder: "RUT razón social",
      formatter: (value) =>
        validaciones.formatRut(value, { showDots: true, showHyphen: true }),
      validationCallback: ({ value }) => validaciones.validateRut(value),
      validationMessage: INPUT_ERRORS.rut,
    },
    {
      inputType: INPUT_TYPES.TEXT,
      name: "folio",
      label: "Folio",
      placeholder: "Folio",
      defaultValue: genFolioNum(),
      disabled: true,
    },
    {
      inputType: INPUT_TYPES.TEXT,
      name: "calle",
      label: "Calle",
      placeholder: "Calle",
      maxLength: 30,
      validationCallback: ({ value }) => validStreet(value),
      validationMessage: INPUT_ERRORS.name,
    },
    {
      inputType: INPUT_TYPES.TEXT,
      name: "numeroDeCalle",
      label: "Número de calle",
      placeholder: "Número de calle",
      maxLength: 10,
      validationCallback: ({ value }) => true,
      validationMessage: INPUT_ERRORS.name,
    },
    {
      inputType: INPUT_TYPES.SELECT,
      name: "region",
      label: "Región",
      placeholder: "Región",
    },
    {
      inputType: INPUT_TYPES.SELECT,
      name: "ciudad",
      label: "Ciudad",
      placeholder: "Ciudad",
    },
    {
      inputType: INPUT_TYPES.SELECT,
      name: "comuna",
      label: "Comuna",
      placeholder: "Comuna",
    },
    {
      inputType: INPUT_TYPES.TEXT,
      name: "correoElectronico",
      label: "Correo electrónico",
      placeholder: "Correo electrónico",
      validationCallback: ({ value }) => validaciones.validarEmail(value),
      validationMessage: INPUT_ERRORS.email,
    },
    {
      // inputType: INPUT_TYPES.NUMBER,
      inputType: INPUT_TYPES.TEXT,
      name: "telefono",
      label: "Teléfono",
      placeholder: "XXXXXXXX",
      // minNum: 10000000,
      validationCallback: ({ value }) => validaciones.validatePhone(value),
      validationMessage: INPUT_ERRORS.phone,
    },
    {
      inputType: INPUT_TYPES.TEXT,
      name: "tasa",
      label: "Tasa",
      placeholder: "Tasa",
      disabled: true,
    },
    {
      inputType: INPUT_TYPES.TEXT,
      name: "nombreRL",
      label: "Nombre Representante Legal",
      placeholder: "Nombre RL",
      maxLength: 30,
      validationCallback: ({ value }) => validName(value),
      validationMessage: INPUT_ERRORS.personName,
    },
    {
      inputType: INPUT_TYPES.TEXT,
      name: "apellidoPaternoRL",
      label: "Apellido Paterno Representante Legal",
      placeholder: "Apellido Paterno Representante Legal",
      maxLength: 30,
      validationCallback: ({ value }) => validName(value),
      validationMessage: INPUT_ERRORS.personName,
    },
    {
      inputType: INPUT_TYPES.TEXT,
      name: "apellidoMaternoRL",
      label: "Apellido Materno Representante Legal",
      placeholder: "Apellido Materno Representante Legal",
      maxLength: 30,
      validationCallback: ({ value }) => validName(value),
      validationMessage: INPUT_ERRORS.personName,
    },
    {
      inputType: INPUT_TYPES.TEXT,
      name: "rutRL",
      label: "RUT Representante Legal",
      placeholder: "RUT Representante Legal",
      formatter: (value) =>
        validaciones.formatRut(value, { showDots: true, showHyphen: true }),
      validationCallback: ({ value }) => validaciones.validateRut(value),
      validationMessage: INPUT_ERRORS.rut,
    },
    {
      inputType: INPUT_TYPES.TEXT,
      name: "correoElectronicoRL",
      label: "Correo electrónico Representante Legal",
      placeholder: "Correo electrónico Representante Legal",
      validationCallback: ({ value }) => validaciones.validarEmail(value),
      validationMessage: INPUT_ERRORS.email,
    },
    {
      inputType: INPUT_TYPES.SELECT,
      name: "tipoRemuneracion",
      label: "Tipo de remuneración",
      placeholder: "Tipo de remuneración",
      options: ["Remuneración", "Gratificación"],
    },
    {
      inputType: INPUT_TYPES.SELECT,
      name: "mesRemuneracion",
      label: "Mes de remuneración",
      placeholder: "Tipo de remuneración",
      options: MESES,
    },
    {
      inputType: INPUT_TYPES.SELECT,
      name: "anoRemuneracion",
      label: "Año de remuneración",
      placeholder: "Tipo de remuneración",
      options: Array.apply(null, new Array(50)).map((v, index) => index + 2010),
    },
  ],

  step2: [
    {
      inputType: INPUT_TYPES.TEXT,
      name: "tasaCotizacion",
      label: "Tasa de cotización ",
      placeholder: "Tasa de cotización" ,
      disabled: true,
    },
    {
      inputType: INPUT_TYPES.TEXT,
      name: "cotizacionAPagar",
      label: "Cotización a pagar",
      placeholder: "Cotización a pagar",
      disabled: true,
      formatter: (value) => noDecimalsFormatter(value),
    },
    {
      inputType: INPUT_TYPES.TEXT,
      name: "reajustes",
      label: "Reajustes",
      placeholder: "Reajustes",
      required: false,
      skipValidation: true,
      formatter: (value) => onlyNumbersFormatter(value),
      disabled: true,
    },
    {
      inputType: INPUT_TYPES.TEXT,
      name: "interesesPenales",
      label: "Intereses Penales",
      placeholder: "Intereses Penales",
      required: false,
      skipValidation: true,
      formatter: (value) => onlyNumbersFormatter(value),
      disabled: true,
    },
    {
      inputType: INPUT_TYPES.TEXT,
      name: "multas",
      label: "Multas",
      placeholder: "Multas",
      required: false,
      skipValidation: true,
      formatter: (value) => onlyNumbersFormatter(value),
      disabled: true,
    },
    {
      inputType: INPUT_TYPES.TEXT,
      name: "totalAPagar",
      label: "Total a pagar",
      placeholder: "Total a pagar",
      disabled: true,
      formatter: (value) => noDecimalsFormatter(value),
    },
  ],
};
